import { useAllowedCustomEventOptions } from 'utils/hooks/useCustomEvents';
import {
  selectIsJourneyGoalsFeatureFlagOn,
  selectIsMissionControlHomepageAndBetaFeatureFlagOn,
} from 'core/userContext';
import { useSelector } from 'react-redux';
import { StyledMultiFilterSelectField } from './ConversionSelect.styled';
import { addGoalsToOptions } from './ConversionSelect.utils';

type ConversionSelectProps = {
  id: string;
  isDisabled: boolean;
  journeyEventName?: string;
  projectEventNames?: string[];
};

/*
 * Drop down for selecting a conversion event,
 * this component is used with react-hook-form as the state container.
 */
export const ConversionSelect = ({
  id,
  isDisabled,
  journeyEventName,
  projectEventNames = [],
}: ConversionSelectProps) => {
  const isJourneyGoalsEnabled = useSelector(selectIsJourneyGoalsFeatureFlagOn);
  const customEventOptions = useAllowedCustomEventOptions();
  const isMissionControlAndBetaEnabled = useSelector(
    selectIsMissionControlHomepageAndBetaFeatureFlagOn,
  );

  const journeyGoalsEventName = isJourneyGoalsEnabled ? journeyEventName : undefined;
  const projectGoalsEventNames = isMissionControlAndBetaEnabled ? projectEventNames : undefined;

  /*
   * If there're journey and/or project goals event passed in and they match any of the options,
   * we make them read only and add a badge indicating that they're inherited from the journey and/or project.
   */
  const options =
    journeyGoalsEventName || (projectGoalsEventNames && projectGoalsEventNames.length > 0)
      ? addGoalsToOptions(customEventOptions, journeyGoalsEventName, projectGoalsEventNames)
      : customEventOptions;

  return (
    <StyledMultiFilterSelectField
      isFullWidth
      name="conversions.events"
      placeholder={'Search or select conversions'}
      options={options}
      data-test={`${id}-form-custom-conversions-events`}
      id={id}
      isDisabled={isDisabled}
    />
  );
};
